<template>
	<el-row>
		<el-select v-model="type" @change="chooseType" placeholder="全部">
			<el-option label="全部" :value="null"></el-option>
			<el-option label="公共节日" :value="1"></el-option>
			<el-option label="专属节日" :value="2"></el-option>
		</el-select>
		<el-button @click="insertFestival()" style="margin-left: 10px;">+添加节日</el-button>
		<el-table :data="tableData">
			<el-table-column label="节日id" prop="festivalId" width="100px"></el-table-column>
			<el-table-column label="节日名称" prop="festivalName"></el-table-column>
			<el-table-column label="节日类型">
				<template slot-scope="scope">
					{{ scope.row.type == 1 ? '公共节日' : scope.row.type == 2 ? '专属节日' : scope.row.type }}
				</template>
			</el-table-column>
			<el-table-column label="节日日期">
				<template slot-scope="scope">
					<p v-if="scope.row.type == 1 && scope.row.dateType == 0">阳历(公历)——{{ scope.row.festivalShowDateStr }}
					</p>
					<p v-if="scope.row.type == 1 && scope.row.dateType == 1">阴历(农历)——{{ scope.row.festivalShowDateStr }}
					</p>
					<p v-if="scope.row.type == 2 && scope.row.dateType == 0">阳历(公历)</p>
					<p v-if="scope.row.type == 2 && scope.row.dateType == 1">阴历(农历)</p>
				</template>
			</el-table-column>
			<el-table-column label="状态" width="50px">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.useStatus" :active-value="0" :inactive-value="1"
						active-color="#13ce66" inactive-color="#ff4949" @change="disSwitch(scope.row)">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button v-if="scope.row.type == 2" type="text" @click="luru(scope.row)">录入</el-button>
					<el-button v-if="scope.row.type == 2" style="color: #f6af03;" type="text"
						@click="viewUser(scope.row)">查看用户</el-button>
					<el-button style="color: #8080ff;" type="text" @click="FestivalInfo(scope.row, 1)">关怀内容</el-button>
					<el-button style="color: #e6a23c;" type="text" @click="FestivalInfo(scope.row, 2)">推荐商品</el-button>
					<el-button style="color: #67c23a;" type="text" @click="updateFestivalInfo(scope.row)">编辑</el-button>
					<el-button style="color: red;" type="text" @click="delFestivalInfo(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-row style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30, 60, 100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</el-row>
		<el-dialog :visible.sync="dialogVisible" :title="title" center width="50%">
			<el-form :model="info" ref="info" :rules="infoRules" label-width="100px" label-position="right">
				<el-form-item label="节日类型:" prop="type" v-if="isShow[0]">
					<el-radio-group v-model="info.type" @change="chooseType2()">
						<el-radio :label="1" :disabled="disable">公共节日</el-radio>
						<el-radio :label="2" :disabled="disable">个人节日</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="日期类型:" prop="dateType" v-if="isShow[0]">
					<el-radio-group v-model="info.dateType">
						<el-radio :label="0">阳历(公历)</el-radio>
						<el-radio :label="1">阴历(农历)</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="节日名称" prop="festivalName" v-if="isShow[0]">
					<el-input v-model="info.festivalName" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="是否修改时间" v-if="info.type == 1 && isXiu2">
					<el-radio-group v-model="isXiu" @change="chooseType3()">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="2">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="*节日日期" v-if="info.type == 1 && !isUpdate">
					<el-input v-model="info.year" style="width: 200px;" placeholder="年份,例如2022" /> ~
					<el-input v-model="info.mouth" style="width: 200px;" placeholder="月份,例如01,12" /> ~
					<el-input v-model="info.day" style="width: 200px;" placeholder="日期,例如01,31" />
				</el-form-item>
				<el-form-item label="*关怀内容:" v-if="isShow[1]">
					<div v-for="(item, index) in info.infoList" :key="index">
						<div style="display: flex;align-items: center;">
							<el-input v-model="item.info" type="textarea" :rows="5" autosize style="width: 350px;">
							</el-input>
							<el-button v-if="info.infoList.length > 1" @click="delInfoList(index)" icon="el-icon-delete"
								type="text"></el-button>
						</div>
					</div>
					<div>
						<el-button type="text" @click="addInfoList">再添加一条+</el-button>
					</div>
				</el-form-item>
				<el-form-item label="推荐商品:" prop="type2" v-if="isShow[2]">
					<el-input v-model="queryList.id" placeholder="请输入商品id" style="width: 120px"></el-input>
					<el-input v-model="queryList.name" placeholder="请输入商品名称" style="width: 200px;margin:0 10px">
					</el-input>
					<el-button type="primary" @click="chaxun()">查询</el-button>
					<div>
						<el-cascader :options="options" :props="props" filterable clearable placeholder="可输入可选择"
							style="width: 350px;margin-top: 10px;" v-model="info.type2">
							<template slot-scope="{ node, data }">
								<span>{{ data.label }}</span>
								<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
							</template>
						</el-cascader>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button @click="dialogVisible = false">取消</el-button>
					<el-button @click="sunbit()" type="primary">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisible2" :title="title" center width="50%">
			<el-input v-model="queryList.id" placeholder="请输入商品id" style="width: 120px"></el-input>
			<el-input v-model="queryList.name" placeholder="请输入商品名称" style="width: 200px;margin:0 10px">
			</el-input>
			<el-button type="primary" @click="chaxun()" style="margin: 0 10px;">查询</el-button>
			<el-cascader :options="options" :props="props" filterable clearable placeholder="可输入可选择"
				style="width: 350px;margin-top: 10px;" v-model="info.type2">
				<template slot-scope="{ node, data }">
					<span>{{ data.label }}</span>
					<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
				</template>
			</el-cascader>
			<el-button type="primary" @click="tj()" style="margin: 0 10px;">添加商品</el-button>
			<el-table :data="tableData2">
				<el-table-column label="ID" prop="id">
				</el-table-column>
				<el-table-column label="名称" prop="name">
				</el-table-column>
				<el-table-column label="图片">
					<template slot-scope="scope">
						<el-image :src="scope.row.pic" style="width: 100px; height: 100px"></el-image>
					</template>
				</el-table-column>
				<el-table-column label="价格" prop="price">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button @click="delInfo(scope.row, scope.$index)">移除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisible3" :title="title" center width="20%">
			<el-form :model="lrForm" ref="lrForm" :rules="lrRules" label-position="right" label-width="65px">
				<el-form-item label="用户id" prop="memberId">
					<el-input v-model="lrForm.memberId" type="number" :disabled="disable"></el-input>
				</el-form-item>
				<el-form-item label="日期" prop="memberDate" v-if="Type">
					<el-date-picker v-model="lrForm.memberDate" type="date" placeholder="选择日期"
						value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="info" @click="dialogVisible3 = false">取消</el-button>
					<el-button type="primary" @click="sumbit2()">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisible4" :title="title" center>
			<el-table :data="tableData3">
				<el-table-column label="id" prop="memberId"></el-table-column>
				<el-table-column label="头像" prop="wxNickname">
					<template slot-scope="scope">
						<el-image :src="scope.row.icon" style="width: 50px;height: 50px;"></el-image>
					</template>
				</el-table-column>
				<el-table-column label="昵称" prop="wxNickname"></el-table-column>
				<el-table-column label="最近关怀时间" prop="careDate"></el-table-column>
				<el-table-column label="创建关怀时间" prop="memberDate"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="bjmember(scope.row)">编辑</el-button>
						<el-button type="text" @click="delmember(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				isXiu: 2,
				isXiu2: false,
				disable: false,
				Type: true,
				tableData: [],
				tableData2: [],
				tableData3: [],
				pageNum: 1,
				pageSize: 30,
				total: 0,
				type: '',
				disable: false,
				dialogVisible: false,
				dialogVisible2: false,
				dialogVisible3: false,
				dialogVisible4: false,
				infoId: 0,
				infoId2: 0,
				title: '',
				isShow: [true, true, true],
				festivalId: 0,
				options: [],
				props: {
					value: "value", //匹配响应数据中的value
					label: "label", //匹配响应数据中的label
					children: "children", //匹配响应数据中的children
					multiple: true
				},
				info: {
					festivalName: "", //节日名称
					type: null, //节日类型（1传统节日，2个人专属）
					dateType: null,
					year: null,
					mouth: null,
					day: null,
					infoList: [{
						info: ''
					}], //关怀
					type2: '' //商品id
				},
				lrForm: {
					memberId: '',
					memberDate: '',
				},
				lrRules: {
					memberId: [{
						required: true,
						message: '请输入用户id',
						trigger: 'change'
					}],
					memberDate: [{
						required: true,
						message: '请选择日期',
						trigger: 'change'
					}]
				},
				queryList: {
					id: '',
					name: ''
				},
				isUpdate: false,
				MonthLength: null,
				infoRules: {
					type: [{
						required: true,
						message: '请选择节日类型',
						trigger: 'change'
					}],
					dateType: [{
						required: true,
						message: '请选择日期类型',
						trigger: 'change'
					}],
					festivalName: [{
						required: true,
						message: '请输入节日名称',
						trigger: 'change'
					}],
					type2: [{
						required: true,
						message: '请选择推荐商品',
						trigger: 'change'
					}],
					festivalId: 0,
				}
			}
		},
		methods: {
			chooseType3() {
				console.log(this.isXiu);
				if (this.isXiu == 2) {
					this.isUpdate = true
				} else {
					this.isUpdate = false
				}
			},
			chooseType() {
				this.getTableList()
			},
			chooseType2() {
				console.log(this.info.type);
				if (this.info.type == 2) {
					this.info.mouth = null
					this.info.year = null
					this.info.day = null
				}
			},
			viewUser(row) {
				console.log(row.dateType);
				if (row.dateType == 0) {

				}
				this.title = row.festivalName + '的用户'
				this.dialogVisible4 = true
				this.tableData3 = []
				this.festivalId = row.festivalId
				this.getMemberFestivalDate(row.festivalId)
			},
			bjmember(row) {
				console.log(row);
				this.dialogVisible3 = true
				this.title = row.festivalName
				this.disable = true
				this.lrForm = {
					memberFestivalId: row.memberFestivalId,
					memberId: row.memberId,
					memberDate: row.memberDate
				}
			},
			delmember(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(
						`/api/plant/festival/delMemberFestivalDate?memberFestivalId=${row.memberFestivalId}`, {}
					).then(res => {
						if (res.data.status == 0) {
							this.$message({
								type: 'success',
								message: '删除成功'
							});
							this.getMemberFestivalDate(row.festivalId)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
					this.dialogVisible4 = true
					this.getMemberFestivalDate(row.festivalId)
				});
			},
			getMemberFestivalDate(festivalId) {
				this.$http.post('/api/plant/festival/selectMemberFestivalDate', {
					"festivalId": festivalId
				}).then(res => {
					console.log(res.data.data);
					this.tableData3 = res.data.data
				})
			},
			luru(row) {
				console.log(row);
				if (row.type == 1) {
					this.Type = false
				} else if (row.type == 2) {
					this.Type = true
				}
				this.dialogVisible3 = true
				this.title = row.festivalName
				this.disable = false
				this.festivalId = row.festivalId
				this.lrForm.memberId = ''
				this.lrForm.memberDate = ''
			},
			sumbit2() {
				this.$refs.lrForm.validate(val => {
					if (val) {
						if (this.disable) {
							this.$http.post('/api/plant/festival/updateMemberFestivalDate',
								this.lrForm
							).then(res => {
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.dialogVisible4 = true
									this.dialogVisible3 = false
									this.getMemberFestivalDate(this.festivalId)
								} else {
									this.$message.success(res.data.msg)
									this.dialogVisible3 = true
								}
							})
						} else {
							this.$http.post('/api/plant/festival/insertMemberFestivalDate', {
								"memberId": this.lrForm.memberId,
								"festivalId": this.festivalId,
								"memberDate": this.lrForm.memberDate
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.dialogVisible3 = false
									this.getTableList()
								}
							})
						}
					}
				})
			},
			getMonthLength(date) {
				let d = new Date(date);
				// 将日期设置为下月一号
				d.setMonth(d.getMonth() + 1);
				d.setDate('1');
				// 获取本月最后一天
				d.setDate(d.getDate() - 1);
				this.MonthLength = d.getDate()
			},
			//确定
			sunbit() {
				var infoList = []
				var infoList2 = []
				var infoList3 = []
				var info = []
				var info2 = []
				console.log(this.info);
				var y = /^(19|20)\d{2}$/
				var m = /(0[1-9]|1[0-2])/
				console.log(this.isUpdate, this.isXiu);
				if (this.info.type == 1) {
					if (this.isUpdate == false && this.isXiu == 1) {
						if (this.info.year == null || this.info.mouth == null || this.info.day == null) {
							this.$message.error('日期未填选全')
							return false
						} else {
							if (!y.test(this.info.year)) {
								this.$message({
									type: 'error',
									message: '请输入正确的年份'
								});
								return false
							}
							if (!m.test(this.info.mouth)) {
								this.$message({
									type: 'error',
									message: '请输入正确的月份'
								});
								return false
							}
							console.log(this.info.mouth);
							this.getMonthLength(this.info.year + '-' + this.info.mouth)
							if (this.info.day > this.MonthLength) {
								this.$message({
									type: 'error',
									message: this.info.year + '年' + this.info.mouth + '月没有' + this.info.day +
										'天，请输入正确天数'
								});
								return false
							}
						}
					}
				}
				this.$refs.info.validate(val => {
					if (val) {
						if (this.info.infoList) {
							let list = this.info.infoList
							if (list.length > 0) {
								for (var i = 0; i < list.length; i++) {
									if (list[i].info == '') {
										this.$message.error('关怀内容未填选全')
										return false
									} else {
										info.push(list[i].info)
									}
								}
							}
							if (this.info.type2.length > 0) {
								this.info.type2.forEach(i => {
									info2.push(i[0])
								})
							}
							infoList.push({
								type: 1,
								info: info
							}, {
								type: 2,
								info: info2
							})
							infoList2.push({
								type: 1,
								info: info
							})
						}
						if (this.title == '添加节日') {
							this.$http.post('/api/plant/festival/insertFestival', {
								"festivalName": this.info.festivalName,
								"type": this.info.type,
								"infoList": infoList,
								"dateType": this.info.dateType,
								"year": this.info.year,
								"mouth": this.info.mouth,
								"day": this.info.day,
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.dialogVisible = false
									this.getTableList()
								} else {
									this.$message.error(res.data.msg)
								}
							}).catch((error) => {
								this.$message.error("发生了一些错误:" + error);
							})
						} else if (this.title == '编辑节日') {
							this.$http.post('/api/plant/festival/updateFestival', {
								"festivalId": this.infoId,
								"type": this.info.type,
								"festivalName": this.info.festivalName,
								"infoList": infoList2,
								"dateType": this.info.dateType,
								"year": this.info.year,
								"mouth": this.info.mouth,
								"day": this.info.day,
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.dialogVisible = false
									this.getTableList()
								} else {
									this.$message.error(res.data.msg)
								}
							}).catch((error) => {
								this.$message.error("发生了一些错误:" + error);
							})
						} else {
							this.$http.post('/api/plant/festival/updateFestivalInfo', {
								"infoId": this.infoId,
								"info": infoList2[0].info,
								"type": 1,
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.dialogVisible = false
									this.getTableList()
								} else {
									this.$message.error(res.data.msg)
								}
							}).catch((error) => {
								this.$message.error("发生了一些错误:" + error);
							})
						}
					}
				})
			},
			tj() {
				console.log(this.info.type2);
				let arr = []
				if (this.info.type2.length > 0) {
					this.info.type2.forEach(item => {
						arr.push(item[0])
					})
					var info = this.info2.concat(arr)
					console.log(info);
					this.$http.post('/api/plant/festival/updateFestivalInfo', {
						"infoId": this.infoId2,
						"type": 2,
						"info": info
					}).then(res => {
						if (res.data.status == 0) {
							this.$message.success('添加成功');
							this.info.type2 = []
							this.queryList.name = ''
							this.queryList.id = ''
							this.getSelectFestivalInfoList(this.festivalId)
						} else {
							this.$message.error('添加失败');
						}
					})
				} else {
					this.$message.error('请先选择商品')
				}
			},
			//关怀和商品弹框
			FestivalInfo(row, num) {
				this.isUpdate = true
				this.isXiu22 = false
				this.info.type = 2
				this.isShow = [false, true, false]
				// this.info.type = row.type
				this.getSelectFestivalInfoList(row.festivalId)
				this.festivalId = row.festivalId
				if (num == 1) {
					this.title = row.festivalName + '的节日关怀'
					this.dialogVisible = true

				} else if (num == 2) {
					this.title = row.festivalName + '的主推商品'
					this.dialogVisible2 = true
				}
			},
			//添加关怀
			addInfoList() {
				this.info.infoList.push({
					info: ''
				})
			},
			//删除添加的关怀
			delInfoList(index) {
				this.info.infoList.splice(index, 1)
			},

			//删除关怀
			delInfo(row, index) {
				console.log(row);
				let info = []
				this.tableData2.forEach(item => {
					info.push(item.id)
				})
				info.splice(index, 1)
				this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/plant/festival/updateFestivalInfo', {
						"infoId": this.infoId2,
						"type": 2,
						"info": info
					}).then(res => {
						if (res.data.status == 0) {
							this.$message.success('删除成功');
							this.getSelectFestivalInfoList(this.festivalId)
						} else {
							this.$message.error('删除失败');
						}
					})
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			//添加节日
			insertFestival() {
				this.isShow = [true, true, true]
				this.title = '添加节日'
				this.dialogVisible = true
				this.isXiu2 = false
				this.isUpdate = false
				this.disable = false
				this.empty()
				this.queryList.id = ''
				this.queryList.name = ''
			},
			//编辑
			updateFestivalInfo(row) {
				console.log('编辑');
				console.log(row);
				this.isXiu = 2
				this.isShow = [true, false, false]
				this.isUpdate = true
				this.isXiu2 = true
				this.disable = true
				this.infoId = row.festivalId
				this.title = '编辑节日'
				this.festivalId = row.festivalId
				this.dialogVisible = true
				this.info = {
					festivalName: row.festivalName, //节日名称
					type: row.type, //节日类型（1传统节日，2个人专属）
					dateType: row.dateType,
					year: row.year,
					mouth: row.mouth,
					day: row.day,
				}
				console.log(this.isXiu);
			},
			//删除
			delFestivalInfo(row) {
				this.$confirm('此操作将永久删除该节日, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/plant/festival/updateFestival', {
						"festivalId": row.festivalId,
						"deleteStatus": 1,
					}).then(res => {
						if (res.data.status == 0) {
							this.getTableList()
							this.$message.success('删除成功');
						} else {
							this.$message.error('删除失败');
						}
					})
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			//修改状态
			disSwitch(row) {
				console.log(row.useStatus);
				this.$http.post('/api/plant/festival/updateFestival', {
					"festivalId": row.festivalId,
					"useStatus": row.useStatus, //上0下1架状态
				}).then(res => {
					console.log(res);
					this.getTableList()
				}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})
			},
			//获取关怀和商品
			getSelectFestivalInfoList(festivalId) {
				this.$http.post('/api/plant/festival/selectFestivalInfoList', {
					"festivalId": festivalId, //节日ID
				}).then(res => {
					console.log(res.data.data);
					let info = res.data.data[0].info
					this.tableData2 = res.data.data[1].productList
					this.info2 = res.data.data[1].info
					this.infoId = res.data.data[0].infoId
					this.infoId2 = res.data.data[1].infoId
					this.info.infoList = []
					if (info.length > 0) {
						info.forEach(item => {
							this.info.infoList.push({
								info: item
							})
						})
					}
				})
			},
			//获取列表
			getTableList() {
				this.$http.post('/api/plant/festival/selectFestivalList', {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					type: this.type
				}).then(res => {
					console.log('节日列表', res.data.data.list);
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})
			},
			//查询商品
			chaxun() {
				this.options = []
				if (this.queryList.id == '' && this.queryList.name == '') {
					this.$message.error('请先填写查询的条件')
					return false
				} else {
					this.getShangpin(this.queryList.name, this.queryList.id)
				}
				console.log(this.options)
			},
			//获取商品信息
			getShangpin(name, id) {
				this.$http.post(
					`/api/course/clrCourse/selectProductName?productName=${name}&id=${id}`, {}
				).then(res => {
					console.log(res.data.data);
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options.push({
								value: i.id,
								label: i.name
							})
						})
					} else {
						this.$message.error('未找到商品')
					}
				}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getTableList()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getTableList()
			},
			//置空
			empty() {
				this.info = {
					festivalName: "", //节日名称
					type: null, //节日类型（1传统节日，2个人专属）
					infoList: [{
						info: ''
					}], //关怀
					type2: '' //商品id
				}
			},
		},
		created() {
			this.getTableList()
		}
	}
</script>
